'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _CwTextField = require('./CwTextField.scss');

var _CwTextField2 = _interopRequireDefault(_CwTextField);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Enums = require('../../utils/Enums');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CwTextField = function (_React$Component) {
  (0, _inherits3.default)(CwTextField, _React$Component);

  function CwTextField() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, CwTextField);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = CwTextField.__proto__ || (0, _getPrototypeOf2.default)(CwTextField)).call.apply(_ref, [this].concat(args))), _this), _this.handleChange = function (e) {
      if (!_this.props.onChange) {
        return;
      }

      var value = e.target.value;

      if (value === '') {
        _this.props.onChange(value);
        return;
      }
      if (_this.props.regex) {
        if (!_this.matchRegex(_this.props.regex, value)) {
          return;
        }
      }
      _this.props.onChange(value);
    }, _this.matchRegex = function (reg, val) {
      var regex = new RegExp(reg, "gm");
      if (regex.test(val)) {
        return true;
      }
      return false;
    }, _this.focus = function () {
      _this.inputField.focus();
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }
  /**
   * This method fires off following a key press for the input field.
   * If the field is enabled it will check for a blank value first and accept it
   * thus accepting back space and then check to see if we have a regex. If we do
   * we need to check if the regex we have matches the value we've been supplied from
   * the event. If so pass it on otherwise, return
   * @param e
   */


  /**
   * This method will take the regex String passed from it's parent, convert it to a regex object
   * and call test against the second parameter. Will retrun true if val passes the regex check.
   * @param reg - The string we want to conver to regex
   * @param val - the string we want to compare against
   * @returns {boolean}
   */


  (0, _createClass3.default)(CwTextField, [{
    key: 'render',
    value: function render() {
      var _cx,
          _this2 = this;

      return _react2.default.createElement('input', {
        'data-cwid': this.props.cwId,
        'data-cwdata': "focusable",
        className: (0, _classnames2.default)(_CwTextField2.default.textField, this.props.className, (_cx = {}, (0, _defineProperty3.default)(_cx, _CwTextField2.default.invalid, this.props.invalid), (0, _defineProperty3.default)(_cx, _CwTextField2.default.alignCenter, this.props.textAlignment ? this.props.textAlignment === _Enums.AlignmentEnum.CENTER : false), (0, _defineProperty3.default)(_cx, _CwTextField2.default.alignRight, this.props.textAlignment ? this.props.textAlignment === _Enums.AlignmentEnum.RIGHT : false), _cx)),
        placeholder: this.props.placeholder,
        readOnly: this.props.readOnly
        //Set value to blank string if value is undefined/null, this removes the controlled/uncontrolled error in the console. 
        , value: this.props.value ? this.props.value : '',
        onChange: this.handleChange,
        onKeyPress: this.props.onKeyPress,
        onFocus: this.props.onFocus,
        onBlur: this.props.onBlur,
        onKeyDown: this.props.onKeyDown,
        onClick: this.props.onClick,
        onKeyUp: this.props.onKeyUp,
        tabIndex: this.props.disabled ? -1 : this.props.tabIndex,
        disabled: this.props.disabled,
        id: this.props.id,
        type: this.props.type,
        maxLength: this.props.maxLength,
        ref: function ref(input) {
          return _this2.inputField = input;
        },
        autoFocus: this.props.autoFocus,
        style: this.props.style
      });
    }
  }]);
  return CwTextField;
}(_react2.default.Component);

CwTextField.propTypes = {
  /**
   * Connectwise element id to be used as unique identifier
   */
  cwId: _propTypes2.default.string,
  /**
   * Text in textfield
   */
  value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  /**
   * Hint text, displayed when user has not typed anything in
   */
  placeholder: _propTypes2.default.string,
  /**
   * Used to set textfield to a read only mode
   */
  readOnly: _propTypes2.default.bool,
  /**
   * Callback function that is fired when textfield's text changes
   */
  onChange: _propTypes2.default.func,
  /**
   * Callback function that is fired when any key is pressed
   */
  onKeyPress: _propTypes2.default.func,
  /**
   * Used to control order when tabbing through items
   */
  tabIndex: _propTypes2.default.number,
  /**
   * Used to control if text is valid
   */
  invalid: _propTypes2.default.bool,
  /**
   * Used to disable textfield
   */
  disabled: _propTypes2.default.bool,
  /**
   * Used as an identifier for the component
   */
  id: _propTypes2.default.string,
  /**
   * Used to limit the inputs of the field by matching against provided string.
   */
  regex: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.instanceOf(RegExp)]),
  /**
   * Callback function that is fired when textfield is focused
   */
  onFocus: _propTypes2.default.func,
  /**
   * Callback function that is fired when textfield is blurred
   */
  onBlur: _propTypes2.default.func,
  /**
   * Callback function that is fired on key down
   */
  onKeyDown: _propTypes2.default.func,
  /**
   * Callback function that is fired on mouse click
   */
  onClick: _propTypes2.default.func,
  /**
   * Callback function that is fired on key up
   */
  onKeyUp: _propTypes2.default.func,
  /**
   * Change the input field type
   */
  type: _propTypes2.default.string,
  /**
   * The maximium number of characters allowed in the field.
   */
  maxLength: _propTypes2.default.number,
  /**
   * Used to control if textfield is autofocused when the page loads
   */
  autoFocus: _propTypes2.default.bool,
  /**
   * An override for text alignments. Checks 'CENTER' and 'RIGHT' as arguments.
   * Will default to left otherwise or if left blank.
   */
  textAlignment: _propTypes2.default.oneOf([_Enums.AlignmentEnum.CENTER, _Enums.AlignmentEnum.RIGHT]),
  /**
   * Override the styles of the root element
   */
  style: _propTypes2.default.object,
  /**
   * The css class name to be appended to default classname
   */
  className: _propTypes2.default.string
};

CwTextField.defaultProps = {
  tabIndex: 0
};

exports.default = CwTextField;


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui/lib/components/cwtextfield/CwTextField.js
// module id = 63
// module chunks = 10